import axios from "axios"
import { useQuery } from "react-query"

export async function getUserCountry(): Promise<string> {
  if (process.env.NODE_ENV === "development") {
    return "DE"
  }
  const { data } = await axios.get(`/api/geo`)
  return data.country_code || ""
}

export const useUserCountry = () => {
  return useQuery("country", getUserCountry)
}
